import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { USER_MODULE_NAMESPACE, USER_INFO, USER_INFO_FIELD, REVERT_USER_INFO, USER_INFO_EDIT, USER_INFO_UPDATE } from '../../../store/user/user-types.store';
import { IUserDetails } from '../../../models/user';
const UserStore = namespace(USER_MODULE_NAMESPACE)
import { UPDATE_ACCOUNT_PROFILE_FUNC } from '../../../common/constants'
import { CrudStatus } from '../../../common/enums';
import { AUTHORIZATION_FUNCTIONALITIES, AUTHORIZATION_MODULE_NAMESPACE } from '../../../store/authorization';


const AuthorizationStore= namespace(AUTHORIZATION_MODULE_NAMESPACE)

@Component({
  components: {
    'email-modification-modal': async () => import("./components/email-motification-modal/EmailModificationModal.vue"),
    'user-profile-enhanced-widget': async () => import("../../../components/user-profile-enhanced-widget/UserProfileEnhancedWidget.vue")
  },
  filters: {
    acronym(value:string){
      if(!value) return
      const [firstname,lastname] = value.trim().split(' ')
      if(!lastname) return firstname.slice(0,2)
      return `${firstname[0]}${lastname[0]}`
    }
  }
})
class ProfileChildAccount extends Vue {


  dtEmailModificationModalVisible: boolean;

  @Prop({ default: false, type: [Boolean] })
  visible: boolean;
  @Prop({ default: false, type: [Boolean] })
  loading: boolean;
  @Prop({ default: false, type: [Boolean] })
  loadUpdateAccount: boolean;
  @Prop({ default: false, type: [Boolean] })
  loadUpdateImage: boolean

  @UserStore.Getter userInfo: IUserDetails;

  @UserStore.Action(USER_INFO)
  storeGetUserInfo: () => Promise<IUserDetails>;

  @UserStore.Mutation(USER_INFO_FIELD)
  storeSetUserInfo;

  @UserStore.Mutation(REVERT_USER_INFO)
  storeRevertUserInfo;

  //@UserStore.Mutation(PROFILE_SET_CR)
  @UserStore.Action(USER_INFO_EDIT)
  storeEditUserInfos: (actionType: string) => void

  @UserStore.Action(USER_INFO_UPDATE)
  storeUpdateUserInfo: (payload: any) => Promise<any>;

  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;

  @UserStore.Getter userCrudActionStatus : CrudStatus

  show1: boolean;
  show2: boolean;
  newPassword: string;
  newPassword2: string;
  rules: { required?: any, min?: any, passwordIsValid?: any, passwordIsMatching?: any };
  fldCellphone: any;
  fldLandline: any;
  accountError: boolean;
  file: any;
  dtDocumentConfigs: { minimum: number, image: { alpha: number }, video: { alpha: number }, document: { alpha: number } }
  loaderValue: any;
  hoverImg: boolean;
  isFirefox: any;
  userInfosHovered: boolean

  constructor() {
    super();
    this.isFirefox = window.navigator.userAgent.indexOf('Firefox') > -1
    this.show1 = false;
    this.show2 = false;
    this.dtEmailModificationModalVisible = false;
    this.newPassword = '';
    this.newPassword2 = '';
    this.fldCellphone = {
      number: '',
      isValid: true,
      country: undefined,
    };
    this.fldLandline = {
      number: '',
      isValid: true,
      country: undefined,
    };
    this.accountError = false;
    this.file = null;
    this.loaderValue = { percentage: 0 };
    this.hoverImg = false;
    this.dtDocumentConfigs = null;
    this.rules = { required: false, min: false, passwordIsValid: false, passwordIsMatching: false };
    this.userInfosHovered= false
  }

  created() {
    this.loadAuths()
  }

  mounted() {
    //this.storeGetUserInfo()
    this.rules = {
      required: value => !!value || this.$t(this.lblSetting.passwordRequired),
      min: v => v.length >= 8 || this.$t(this.lblSetting.passwordMin),
      passwordIsValid: v => this.passwordValid(v) || this.$t(this.lblSetting.passwordValid),
      passwordIsMatching: v => this.passwordMatch(v) || (this.$t(this.lblSetting.passwordMatching))
    };
    this.dtDocumentConfigs = require('../../../configs/ticket-document-maxsize.config.json');
  }

  destroyed() {
    this.storeRevertUserInfo()
  }

  loadAuths(): any {
    return this.storeGetFunctionalities('profile')
     .then( response => {
        if(this.$route.meta) Object.keys(response).forEach( key => this.$route.meta[key] = true )
        this.$forceUpdate()
        return this.$route.meta
     })
  }

  get isUserUpdateAction(): boolean {
    return this.userCrudActionStatus === CrudStatus.Update
  }

  get email() : string {
    return this.userInfo.email
  }

  get address(): any {
    return this.userInfo.address
  }

  get cellphone() {
    return this.userInfo.cellphone
  }

  set cellphone(params) {
    this.storeSetUserInfo({ cellphone: params })
  }

  get landline() {
    return this.userInfo.landline
  }

  set landline(params) {
    this.storeSetUserInfo({ landline: params })
  }

  get notificationApp() {
    return this.userInfo.notification_app
  }

  set notificationApp(params) {
    this.storeSetUserInfo({ notification_app: params })
  }

  get notificationSms() {
    return this.userInfo.notification_sms
  }

  set notificationSms(params) {
    this.storeSetUserInfo({ notification_sms: params })
  }

  get notificationMail() {
    return this.userInfo.notification_mail
  }

  set notificationMail(params) {
    this.storeSetUserInfo({ notification_mail: params })
  }

  get fullname(): string{
    return `${this.userInfo.firstname} ${this.userInfo.lastname}`
  }

  get lblSetting() {
    return {
      ...require('../../../locales/profile').default,
      ...require('../../../locales/button').default,
      ...require('../../../locales/generic-labels').default,
      ...require('../../../locales/validation-messages').default
    }
  }

  get roleValue() {
    switch (this.userInfo.role) {
      case 'manager':
        return this.$t(this.lblSetting.manager)
      case 'manager-admin':
        return this.$t(this.lblSetting.managerAdmin)
      case 'tenant':
        return this.$t(this.lblSetting.tenant)
      case 'owner':
        return this.$t(this.lblSetting.owner)
      case 'independent_contractor':
        return this.$t(this.lblSetting.independentContractor)
      case 'concierge':
        return this.$t(this.lblSetting.caretaker)
      case 'Internal_contractor':
        return this.$t(this.lblSetting.internalContractor)
      case 'salesperson':
        return this.$t(this.lblSetting.salesperson)
      case 'customer':
        return this.$t(this.lblSetting.customer)
      case 'superadmin':
        return this.$t(this.lblSetting.administrator)
      default:
        return this.userInfo.role
    }
  }

  localStorageUserInfo() {
    return JSON.parse(localStorage.getItem('user'))
  }
  /*
      Handles a change on the file upload
  */
  async handleFileUpload({ files }) {
    if (files.length === 0) return;
    const maxSize: number = this.calculateMaxSize('image');
    if (maxSize < files[0].size) {
      alert(`File too large. The size can not exceed ${maxSize / 1024 / 1024}`);
      return;
    }
    await this.getBase64URL(files[0])
      .then((fileReader: FileReader) => {
        const file = files[0];
        file.id = `${file.lastModified}`;
        fileReader.onloadend = () => {
          file.url = fileReader.result;
        }
        return Promise.resolve(file)
      })
      .then(file => {
        setTimeout(() => {
          this.file = file;
          this.loaderValue.percentage= 100
          this.$emit('updateImage',file.url)
        }, 100);
      })
      .catch(error => console.log(error))
  }

  handleNotificationChange(change){
    let params= {}
    this.paramNotifications(params)
    this.$emit('updateNotifications',params)
  }

  handleClickPicture() {
    if(!this.loadUpdateImage && this.$route.meta['update_profile_picture']) (this.$refs['file'] as any).click();
  }

  handleImageMouseOver(){
    if(this.$route.meta['update_profile_picture']) this.hoverImg= true
  }

  handleImageMouseLeave(){
    this.hoverImg= false
  }



  handleMouseHover(){
    if(this.$route.meta['edit_account_setting']) this.userInfosHovered= true
  }

  handleMouseLeave(){
    this.userInfosHovered= false
  }

  handleUpdateInfos(){
    this.userInfosHovered= false
    this.storeEditUserInfos('PROFILE')
  }

  handleUpdateSignature() {
    this.storeEditUserInfos('SIGNATURE')
  }

  passwordValid(v) {
    let empty = /\s/
    let reg = /[a-zàäâéèêëïîöôùüû]/
    let regMaj = /[A-Z]/
    let num = /[1-9]/
    return !empty.test(v) && reg.test(v) && regMaj.test(v) && num.test(v)
  }

  passwordMatch(v) {
    return v === this.newPassword
  }

  paramPhones(params) {
    if (this.cellphone !== this.localStorageUserInfo().cellphone) {
      params.cellphone = this.cellphone;
    }
    if (this.landline !== this.localStorageUserInfo().landline) {
      params.landline = this.landline;
    }
  }

  paramPassword(params) {
    params.password = this.newPassword;
  }

  paramImage(params) {
    params.picture = this.file.url;
    params.percentage = 0;
    this.loaderValue = params;
  }

  paramNotifications(params) {
    if (this.notificationApp !== this.localStorageUserInfo().notification_app)
      params.notification_app = this.notificationApp
    if (this.notificationMail !== this.localStorageUserInfo().notification_mail)
      params.notification_mail = this.notificationMail
    if (this.notificationSms !== this.localStorageUserInfo().notification_sms)
      params.notification_sms = this.notificationSms
  }

  updatePhones(params) {
    if (this.cellphone === this.localStorageUserInfo().cellphone &&
      this.landline === this.localStorageUserInfo().landline) {
      // No changes
    } else if (!this.fldCellphone.isValid || !this.fldLandline.isValid) {
      this.accountError = true;
    } else {
      this.paramPhones(params)
    }
  }

  updatePassword(params) {
    if (this.passwordValid(this.newPassword) && this.passwordMatch(this.newPassword2)) {
      this.paramPassword(params)
    } else if (this.newPassword && this.newPassword2) {
      this.accountError = true;
    }
  }

  updateImage(params) {
    if (this.file !== null) {
      this.paramImage(params)
    }
  }

  updateNotifications(params) {
    this.paramNotifications(params)
  }

  onUpdateAccount() {
    let params = {}
    this.accountError = false;
    this.updateImage(params)
    this.updatePhones(params)
    this.updatePassword(params)
    this.updateNotifications(params)
    //console.log(params)
    //console.log(this.accountError)
    let hasParam = Object.keys(params).length > 0
    if (!this.accountError && hasParam) {
      // I don't translate sentence below because popup is not used currently
      this.$emit('display-profile-update-modal', 'Compte', 'Êtes-vous sûr de vouloir mettre à jour vos informations ?',
        UPDATE_ACCOUNT_PROFILE_FUNC, params)
    }
  }

  onInputCellphone({ number, isValid, country }) {
    this.fldCellphone.number = number;
    this.fldCellphone.isValid = isValid;
    this.fldCellphone.country = country && country.name;
  }

  onInputLandline({ number, isValid, country }) {
    this.fldLandline.number = number;
    this.fldLandline.isValid = isValid;
    this.fldLandline.country = country && country.name;
  }

  private async getBase64URL(file): Promise<FileReader> {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    return Promise.resolve(fileReader);
  }

  private calculateMaxSize(type): number {
    return this.dtDocumentConfigs[type].alpha * this.dtDocumentConfigs.minimum
  }

  _clearTimeout: any
  handleEditEmail() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.dtEmailModificationModalVisible = true;
    }, 300);
  }
}

export default ProfileChildAccount;



// WEBPACK FOOTER //
// ./src/containers/profile/profile-child-account/index.ts